// @flow

import * as React from "react"
import {NavLink, withRouter} from "react-router-dom"
import {withTranslation} from "react-i18next"

type Props = {
  +match: any,
  +t: any,
  +isSaving: boolean,
}

class IntakeDataNav extends React.Component<Props> {
  render() {
    const {
      t,
      isSaving,
      match: {
        params: {babyToken},
      },
    } = this.props
    const saveState = isSaving
      ? t("intake.saveState.saving")
      : t("intake.saveState.saved")
    return (
      <div className="intake-data-nav mb-5">
        <ul className="subnav">
          <li className="subnav-item">
            <NavLink
              to={`/intake/${babyToken}/data/general`}
              className="subnav-link"
              activeClassName="is-active"
            >
              {t("intake.data.nav.data")}
            </NavLink>
          </li>
          <li className="subnav-item">
            <NavLink
              to={`/intake/${babyToken}/data/survey`}
              className="subnav-link"
              activeClassName="is-active"
            >
              {t("intake.data.nav.survey")}
            </NavLink>
          </li>
          <li className="subnav-item">
            <NavLink
              to={`/intake/${babyToken}/data/info`}
              className="subnav-link"
              activeClassName="is-active"
            >
              {t("intake.data.nav.info")}
            </NavLink>
          </li>
          {isSaving != null && <li className="text-gray">{saveState}</li>}
        </ul>
      </div>
    )
  }
}

export default withTranslation()(withRouter(IntakeDataNav))
